// extracted by mini-css-extract-plugin
export default {"nav":"_pagination_nav__iJJ+W","button":"_pagination_button__EL8G+","arrowButton":"_pagination_arrowButton__uej3O"};